import React from "react";
import String from "Components/String.js";

const UiBarTitle = <String bold={true} str="HOPS" variant="h6" />;

export default UiBarTitle;
